import { Component, effect, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FeedbackConfirmationPopupService } from '../../../services/feedback-confirmation-popup/feedback-confirmation-popup.service';
import { UrlService } from '../../../services/url-service/url.service';
import { DialogPopupComponent } from '../../dialog-popup/dialog-popup.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'feedback-confirmation-popup',
  imports: [DialogPopupComponent, RouterLink, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './feedback-confirmation-popup.component.html',
})
export class FeedbackConfirmationPopupComponent {
  private readonly dialogPopup = viewChild<DialogPopupComponent>('feedbackConfirmationDialog');
  protected readonly feedbackConfirmationUrl =
    this.feedbackConfirmationPopupService.feedbackConfirmationUrl;

  constructor(
    private readonly feedbackConfirmationPopupService: FeedbackConfirmationPopupService,
    private readonly urlService: UrlService,
  ) {
    effect(() => {
      if (this.feedbackConfirmationUrl()) {
        this.dialogPopup()?.openDialog();
      }
    });
  }

  protected continueToFeedback(): void {
    const url = this.feedbackConfirmationUrl();
    this.closeFeedbackConfirmationDialog();

    if (url) {
      this.urlService.openURL(url);
    }
  }

  protected closeFeedbackConfirmation(): void {
    this.feedbackConfirmationPopupService.closeFeedbackConfirmation();
  }

  protected closeFeedbackConfirmationDialog(): void {
    this.closeFeedbackConfirmation();
    this.dialogPopup()?.closeDialog();
  }
}
